import { type DynamicGalleryCollection, type DynamicGalleryLayout } from "@jti/fe-common";

import { getStickImageStyles } from "../../utils";

import "./ProductDynamicBundleGallery.scss";

interface ProductDynamicBundleGalleryProps {
  imageCollection: DynamicGalleryCollection[];
  template?: DynamicGalleryLayout;
}

export const ProductDynamicBundleGallery: React.FC<ProductDynamicBundleGalleryProps> = ({
  imageCollection,
  template = "without-layout",
}) => {
  //multiplicator depends on look and feel of topMargins
  const chooseMultiplicator = (template: DynamicGalleryLayout) => {
    switch (template) {
      case "layout-sticks-only":
      case "layout-2-products":
        return 0.84;
      case "layout-3-products":
        return 1.12;
      case "layout-3-products-1-horizontal":
        return 0.54;
      default:
        return 1;
    }
  };

  const renderSimpleImage = (url: string, index = 0) => {
    return url && <img className="product-dynamic-bundle-gallery__image" key={index} src={url} alt="" />;
  };

  const renderSingleStickImage = (url: string, index = 0, length: number) => {
    const multiplicator = chooseMultiplicator(template);
    const sticksWrapperStyle = getStickImageStyles(index, length, multiplicator);

    return (
      url && (
        <img
          className="product-dynamic-bundle-gallery__image--sticks"
          style={sticksWrapperStyle}
          key={index}
          src={url}
          alt=""
        />
      )
    );
  };

  const renderSticksContainer = (sticks: string[], optionId: number) => {
    return (
      <div
        key={optionId}
        data-testid="product-dynamic-bundle-gallery__sticks-wrapper"
        className={`product-dynamic-bundle-gallery__sticks-wrapper`}
      >
        <div className={"product-dynamic-bundle-gallery__sticks-container"}>
          {sticks.map((url: string, index: number) => renderSingleStickImage(url, index, sticks.length))}
        </div>
      </div>
    );
  };

  const renderBlockTemplate = (item: DynamicGalleryCollection) => {
    return (
      <>
        {Array.isArray(item.placeholderImage)
          ? renderSticksContainer(item.placeholderImage, item.optionId)
          : renderSimpleImage(item.placeholderImage, 0)}
      </>
    );
  };

  return (
    <div data-testid="product-dynamic-bundle-gallery" className="product-dynamic-bundle-gallery">
      <div
        data-testid="product-dynamic-bundle-gallery__template"
        className={`product-dynamic-bundle-gallery__template product-dynamic-bundle-gallery__template--${template}`}
      >
        {imageCollection.map((item: DynamicGalleryCollection) => renderBlockTemplate(item))}
      </div>
    </div>
  );
};
